import styled from '@emotion/styled';

import Button from 'components/field/Button';
import Card from 'components/global/Card';

export const PageContainer = styled(Card)`
	display: flex;
	flex-direction: column;
`;

export const PageHeaderActionContainer = styled.div`
	display: flex;
	gap: 1rem;
`;

export const CartBadge = styled.div`
	background: #e3e6f6;
	color: var(--blue);
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	min-width: 2.5rem;
	min-height: 2.5rem;
`;

export const ProductsContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(31rem, 1fr));
	max-height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	grid-gap: 2.5rem 1.5rem;

	@media only screen and (min-width: 1400px) {
		grid-template-columns: repeat(5, minmax(28rem, 1fr));
	}
`;

export const ProductContainer = styled.div`
	display: flex;
	flex-direction: column;
	position: relative;
	gap: 2rem;
	place-self: center;
	background: transparent;
	border: none;
	text-align: left;
	max-width: 28rem;
	cursor: pointer;
	place-items: center;
	:hover > .add-cart {
		visibility: visible;
		opacity: 1;
	}
	:hover > .product-image {
		transform: scale(1.03);
		transition: transform 0.3s;
	}
`;

export const AddToCartButton = styled(Button)`
	visibility: hidden;
	position: absolute;
	opacity: 0;
	z-index: 1;
	right: 1rem;
	top: 1rem;
`;

export const ProductContent = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const LoadingRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	place-self: center;
	width: 100%;
	max-width: 28rem;
`;

export const SearchInfoContainer = styled.div`
	display: flex;
	margin-bottom: 1rem;
	align-items: center;
`;
